import React from 'react';
import {
  elementAttributesToProps,
  RehydratorFunction,
} from '@tr-digital/react-rehydrate';
import { ISupportTicketProps } from '../types';
import { SupportTicket } from '../SupportTicket';

const rehydrator: RehydratorFunction = async (domNode) => {
  const props: ISupportTicketProps = elementAttributesToProps(domNode);

  return Promise.resolve(<SupportTicket {...props} />);
};

export default rehydrator;
